module.exports = __webpack_public_path__ + "static/media/sms-plain.0091658c.png";